import React from "react"
import { useHistory } from "react-router-dom"

import "../../assests/styles/pageNotFound.scss"
import { routes } from "../../constantes/routes"


const PageNotFound = () => {
    const history = useHistory()

    return (
        <div className="center">
            <div className="error">
                <div className="number">4</div>
                <div className="illustration">
                    <div className="circle" />
                    <div className="clip">
                        <div className="paper">
                            <div className="face">
                                <div className="eyes">
                                    <div className="eye eye-left" />
                                    <div className="eye eye-right" />
                                </div>
                                <div className="rosyCheeks rosyCheeks-left" />
                                <div className="rosyCheeks rosyCheeks-right" />
                                <div className="mouth" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="number">4</div>
            </div>
            <h1 className="white-text text">
                Oops. La página que buscas no existe.
            </h1>
            <button className='btn save' type='button' onClick={() => history.push(routes.MAIN)} >
                Principal
            </button>
        </div>
    )
}
export default PageNotFound